// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_videoWrapper__OnZEk iframe {
  max-width: calc(100vw - 200px);
  aspect-ratio: 16 / 9;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/resource/details/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".videoWrapper :global iframe {\n  max-width: calc(100vw - 200px);\n  aspect-ratio: 16 / 9;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"videoWrapper": `styles_videoWrapper__OnZEk`
};
export default ___CSS_LOADER_EXPORT___;
